import useContentful from '../api/useContentful';

export default function usePressEvents() {
  const { data, isLoading } = useContentful('3IZ5jPu8jDBoZCTNUEtnni');

  const sections = data?.sections || [];
  
  return {
    sections,
    isLoading
  };
}
